import React from 'react';
import {
    Header, Segment, Tab, Responsive
} from 'semantic-ui-react';
import { ToastContainer } from 'react-toastify';
import CreateQuestion from './CreateQuestion/CreateQuestion';
import PollInfo from './PollInfo/PollInfo';
import AdminPollPreview from './PollPreview/AdminPollPreview';
import AddExistingQuestion from './CreateQuestion/AddExistingQuestion';
import CopyQuestions from "./CopyQuestions";

export default class PollPreviewTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pollQuestions: null,
            activeIndex:
                props.location &&
                props.location.state &&
                typeof props.location.state.activeIndex === 'number'
                    ? props.location.state.activeIndex
                    : 0
        };

        this.handleTabChange = this.handleTabChange.bind(this);
        this.goToQuestionsTab = this.goToQuestionsTab.bind(this);
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
    }

    goToQuestionsTab() {
        this.setState({ activeIndex: 1 });
    }

    render() {
        const panes = [
            {
                menuItem: 'Osnovne informacije',
                render: () => (
                    <Tab.Pane as={Responsive}>
                        <PollInfo />
                    </Tab.Pane>
                )
            },
            {
                menuItem: 'Prikaz pitanja',
                render: () => (
                    <Tab.Pane as={Responsive}>
                        <AdminPollPreview />
                    </Tab.Pane>
                )
            }
        ];

        if (localStorage.getItem('edit') === 'enable') {
            panes.push({
                menuItem: 'Kopiranje ankete',
                render: () => (
                    <Tab.Pane as={Responsive}>
                        <CopyQuestions
                            {...this.props}
                            goToQuestionsTab={this.goToQuestionsTab}
                        />
                    </Tab.Pane>
                )
            });
            panes.push({
                menuItem: 'Kreiranje novog pitanja',
                render: () => (
                    <Tab.Pane as={Responsive}>
                        <CreateQuestion />
                    </Tab.Pane>
                )
            });
            panes.push({
                menuItem: 'Dodavanje postojećeg pitanja',
                render: () => (
                    <Tab.Pane as={Responsive}>
                        <AddExistingQuestion />
                    </Tab.Pane>
                )
            });
        }

        return (
            <div>
                <h1>Detalji</h1>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            Naziv: {JSON.parse(localStorage.getItem('poll')).pollName}
                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Tab
                            menu={{ secondary: true, pointing: true, color: 'blue' }}
                            panes={panes}
                            activeIndex={this.state.activeIndex}
                            onTabChange={this.handleTabChange}
                        />
                    </Segment>
                </Segment.Group>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollPreviewTabs/PollPreviewTabs.js